<template>
  <bcc-dialog :visible="show" width="500px" @close="handleCompanyDialog(false)">
    <div slot="title">
      <h3>身份认证</h3>
    </div>
    <div>请完成身份信息填写，审核通过后即可创建应用，拥有稿件分发等开发者能力。</div>
    <div style="margin-top:10px">如果您是被授权用户，请前往【管理中心】-【授权管理】接受授权邀请</div>

    <div slot="footer">
      <bcc-button size="large" class="write-btn" type="primary" @click="enterCompanyAdd()"
        >去填写</bcc-button
      >
      <bcc-button size="large"  @click="handleAccept"
        >去接受邀请</bcc-button
      >
    </div>
  </bcc-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CompanyDialog',
  mounted() {
    setTimeout(() => {
      this.routerVerify()
    }, 100)
    this.$bus.$on('showCompanyDialog', this.handleCompanyDialog)
  },
  data: () => {
    return {
      showCompanyDialog: false,
    }
  },
  computed: {
    ...mapState(['companyInfo', 'userInfo']),
    show() {
      // 是否出现认证弹窗: 登陆 && 没有企业认证信息 && showDialog
      return this.userInfo && !this.companyInfo && this.showCompanyDialog
    },
  },
  beforeDestroy() {
    this.$bus.$off('showCompanyDialog', this.handleCompanyDialog)
  },
  methods: {
    handleAccept () {
      this.handleCompanyDialog(false)
      this.$router.push({ name: 'auth' })
    },
    handleCompanyDialog(bol) {
      this.showCompanyDialog = bol
    },
    enterCompanyAdd() {
      this.handleCompanyDialog(false)
      this.$router.push({ name: 'companyAdd' })
    },
    routerVerify() {
      if (this.$route.fullPath === '/') {
        this.handleCompanyDialog(true)
      } else {
        this.handleCompanyDialog(false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .write-btn {
    width: 120px;
    margin-right: 50px!important;
  }
</style>